import { CheckCircleTwoTone, WarningTwoTone } from '@mui/icons-material';
import { Button, Card, CardActions, CardContent, Divider, Grid, Stack, Typography } from '@mui/material';
import { t } from 'i18next';
import { Resources, Translation } from '../../../@types/i18next';
import EmptyExceptions from '../../../assets/images/empty-exceptions.svg';
import { Interpolation } from '../../../config/i18n/components/Interpolation';
import { DocsAlert } from '../../../common/docs/DocsAlert';
import { UrlHelper } from '../../../common/utils/UrlHelper';
import { EXTERNAL_URLS } from '../../../routing/routes';

type Props = {
  onAddException?: () => void;
};

type ExampleProps = {
  status: 'good' | 'bad';
  i18nKey: Translation<Resources>;
};

const ExampleException = ({ status, i18nKey }: ExampleProps) => {
  return (
    <Stack spacing={2}>
      {status === 'bad' && <WarningTwoTone color="warning" />}
      {status === 'good' && <CheckCircleTwoTone color="success" />}
      <Interpolation
        i18nKey={i18nKey}
        variant="body2"
        items={[
          { name: 'color_green', color: '#2E7D32' },
          { name: 'color_red', color: '#D72A28' },
        ]}
      />
    </Stack>
  );
};

export const BlankState = ({ onAddException }: Props) => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ py: 4 }}>
          <EmptyExceptions role="img" title={t('exceptionsBlankState.message')} />
          <Typography>{t('exceptionsBlankState.message')}</Typography>
          {onAddException && (
            <Button color="primary" variant="contained" onClick={onAddException}>
              {t('addException')}
            </Button>
          )}
          {!onAddException && <Typography variant="body2">{t('exceptionsBlankState.noPermission')}</Typography>}
        </Stack>
        <Divider sx={{ py: 2 }}>
          <Typography variant="overline">{t('tipsAndHints')}</Typography>
        </Divider>
        <Grid container columns={3} spacing={2} sx={{ width: 1, px: 2 }}>
          <Grid item xs={3} md={1}>
            <ExampleException status="bad" i18nKey="exceptionsExamples.bad1" />
          </Grid>
          <Grid item xs={3} md={1}>
            <ExampleException status="bad" i18nKey="exceptionsExamples.bad2" />
          </Grid>
          <Grid item xs={3} md={1}>
            <ExampleException status="good" i18nKey="exceptionsExamples.good1" />
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ p: 0, pt: 2 }}>
        <DocsAlert helpText="exceptionsGuidance" href={UrlHelper.wrapExternalDocsUrl(EXTERNAL_URLS.DOCS_EXCEPTIONS)} fullWidth />
      </CardActions>
    </Card>
  );
};
